import { feeCreateBody } from "gen/schemas/fees/fees";
import i18n from "i18n/config";
import { z, ZodIssueCode } from "zod";

export const feeFormSchema = z.intersection(
  feeCreateBody,
  z
    .object({
      applies_to_all_funds: z.boolean(),
      fund_ids: z.array(z.string()),
      fee_calculations: z.array(
        z
          .object({
            named_start_date_id: z.string(),
            custom_start_date: z.string(),
            named_end_date_id: z.string(),
            custom_end_date: z.string(),
          })
          .partial(),
      ),
    })
    .partial()
    .superRefine((val, ctx) => {
      if (!val.applies_to_all_funds && !val.fund_ids?.length) {
        ctx.addIssue({
          code: ZodIssueCode.too_small,
          minimum: 1,
          type: "array",
          inclusive: true,
          path: ["fund_ids"],
        });
      }
      const startDates = new Set();
      const endDates = new Set();
      val.fee_calculations?.forEach((calc, index, array) => {
        const isLast = index === array.length - 1;
        checkDate(
          ["fee_calculations", index, "named_start_date_id"],
          ["fee_calculations", index, "custom_start_date"],
          startDates,
          calc.named_start_date_id,
          calc.custom_start_date,
          true,
          ctx,
        );
        checkDate(
          ["fee_calculations", index, "named_end_date_id"],
          ["fee_calculations", index, "custom_end_date"],
          endDates,
          calc.named_end_date_id,
          calc.custom_end_date,
          !isLast,
          ctx,
        );
      });
    }),
);

const checkDate = (
  namedDateFieldPath: (string | number)[],
  customDateFieldPath: (string | number)[],
  existingDates: Set<unknown>,
  namedDateId: string | null | undefined,
  customDate: string | null | undefined,
  isRequired: boolean,
  ctx: z.RefinementCtx,
) => {
  const value = namedDateId === "custom" ? customDate : namedDateId;
  if (value) {
    if (namedDateId === "custom" && !customDate) {
      ctx.addIssue({
        code: ZodIssueCode.invalid_type,
        expected: "date",
        received: "null",
        path: customDateFieldPath,
      });
      return;
    }
    if (existingDates.has(value)) {
      ctx.addIssue({
        code: ZodIssueCode.invalid_date,
        message: i18n.t("fees:errors.timePeriod"),
        path: namedDateFieldPath,
      });
    } else {
      existingDates.add(value);
    }
  } else if (isRequired) {
    ctx.addIssue({
      code: ZodIssueCode.too_small,
      minimum: 1,
      type: "string",
      inclusive: true,
      path: namedDateFieldPath,
    });
  }
};
